import { ApolloClient, HttpLink, InMemoryCache, gql } from '@apollo/client';
import ReactOnRails from 'react-on-rails';

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: '/jwgql',
    credentials: 'same-origin',
    fetch: (uri, options) => {
      options.headers['X-CSRF-Token'] = ReactOnRails.authenticityToken();
      return fetch(uri, options);
    },
  }),
  resolvers: {
    ContactList: {
      isSelected: list => Boolean(list.isSelected),
    },
    Query: {
      currentUserCanEditCurrentOrganization: (_user, _args, { cache }) => {
        const { currentUser, currentOrganization } = cache.readQuery({
          query: gql`
            query IsCurrentOrganizationAdmin {
              currentUser @client {
                role
                organizations {
                  id
                }
              }
              currentOrganization @client {
                id
              }
            }
          `,
        });

        return (
          Boolean(currentUser) &&
          (currentUser.role === 'admin' ||
            (currentUser.role === 'organizer' &&
              currentUser.organizations
                .map((organization: any) => organization.id)
                .includes(currentOrganization.id)))
        );
      },
    },
  },
  connectToDevTools: false,
});

export default client;
